import { GET_SELECTS_DATA } from "@/store/selectsData.module";

/**
 * Loads incoterm options and keeps selected incoterm visible in autocomplete.
 */
export default {
  data() {
    return {
      incotermOptions: [],
    };
  },
  methods: {
    async loadIncoterms() {
      try {
        const response = await this.$store.dispatch(GET_SELECTS_DATA, ["incoterms"]);
        const items = response.incoterms || [];
        this.incotermOptions = items.map((item) => ({
          id: Number(item.key ?? item.id),
          label: item.name || item.value || item.code || String(item.key ?? item.id),
          code: item.code || item.name,
          include_transport: item.include_transport,
        }));
      } catch (error) {
        this.incotermOptions = [];
      }
    },
    mergeIncotermOption(incoterm) {
      if (!incoterm || !incoterm.id) {
        return;
      }
      const option = {
        id: Number(incoterm.id),
        label: incoterm.code
          ? `${incoterm.code} — ${incoterm.name || incoterm.code}`
          : incoterm.name || String(incoterm.id),
        code: incoterm.code,
        include_transport: incoterm.include_transport,
      };
      if (!this.incotermOptions.some((item) => Number(item.id) === option.id)) {
        this.incotermOptions = [option, ...this.incotermOptions];
      }
    },
    syncIncotermFromDocument(data) {
      if (data.incoterm) {
        this.mergeIncotermOption(data.incoterm);
      } else if (data.incoterm_id) {
        const existing = this.incotermOptions.find(
          (item) => Number(item.id) === Number(data.incoterm_id)
        );
        if (!existing) {
          this.incotermOptions = [
            {
              id: Number(data.incoterm_id),
              label: String(data.incoterm_id),
            },
            ...this.incotermOptions,
          ];
        }
      }
    },
  },
};
